import React from 'react';

type Props = React.SVGProps<SVGSVGElement>;

export default function IconChevronDown(props: Props) {
  return (
    <svg
      width={12}
      height={8}
      viewBox='0 0 12 8'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
      focusable='false'
      {...props}
    >
      <path d='M1 1l5 5 5-5' fill='none' stroke='currentColor' strokeWidth={2} />
    </svg>
  );
}
